import { Navigate } from 'react-router-dom';
import Layout from 'components/Layout';
import useLiterals from 'utils/hooks/useLiterals';
import Lottie from 'react-lottie';
import * as animationData from 'assets/animations/maintenance.json';
import { APP_STORE_URL } from 'constants/global';
import LogoAndroid from 'assets/images/play-store.png';
import LogoApple from 'assets/images/app-store.png';
import Button from 'components/UI/Button';
import platform from 'utils/platform';
import './styles.scss';

const UpdateApp = () => {
  const literals = useLiterals('updateApp');

  // Si no es app nativa, redirigir al inicio — la actualización no aplica en browser
  if (!platform.isNativeApp) return <Navigate to='/' replace />;

  const openStoreLink = (to) => {
    window.openExternalLink(to);
  };

  return (
    <Layout rightMenu={false} className='text-center'>
      <div className='update-app'>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          width={275}
        />
        <h1 className='mb-2'>{literals.title}</h1>
        <p className='mt-4 mb-12'>
          {literals.description}
        </p>
        {platform.isAndroid && (
          <Button onClick={() => openStoreLink(APP_STORE_URL.ANDROID)} className='mb-6' type='secondary'>
            <img src={LogoAndroid} alt='Platform logo' />
            Play Store
          </Button>
        )}
        {platform.isIOS && (
          <Button onClick={() => openStoreLink(APP_STORE_URL.IOS)} type='secondary'>
            <img src={LogoApple} alt='Platform logo' />
            App Store
          </Button>
        )}
      </div>
    </Layout>
  );
};

export default UpdateApp;
